export default __webpack_public_path__ + "static/5-3a6de42725a71d9020c16a420eee9894.webp";